<template>
  <div
    class="container-fluid mycontainer-fluid content"
    v-if="$parent.rerender"
  >
    <a ref="target" id="target"></a>
    <fieldset
      :disabled="isResumeCoordinated"
      style="border: 0; padding: 0; margin: 0;"
    >
    <div class="content-title content-mb-14">
      <template v-if="project.UF_SETTING.IS_VIEW_FINACIAL_INDICATORS == 1">
        <span
          v-if="
            $parent.project.UF_DIRECTION_FINANCING_ID > 0 &&
              project.UF_SETTING.IS_MOB_BUILDING_STRUCTURES == 1
          "
          >{{ 13 + okpoShift + mobOkpdShift }}.</span
        >
        <span v-else-if="project.UF_DIRECTION_FINANCING_ID > 0"
          >{{ 14 + okpoShift + mobOkpdShift }}.</span
        >
        <span v-else>{{ 13 + okpoShift + mobOkpdShift }}.</span>
      </template>
      <span v-else>{{ 12 + okpoShift + mobOkpdShift }}.</span>
      Бюджет проекта в части расходования средств займа Фонда, тыс. руб.
      <a v-on:click="h16tooltipShow = !h16tooltipShow" class="icon-help"></a>
      <img
        v-on:click="h16tooltipShow = false"
        v-show="h16tooltipShow && !$parent.modalIsOpened"
        src="https://lkbe.frprf.ru//images/project/p15_info.png"
        style="
            margin-left: 32px;
    margin-top: 20px;
        height: 800px;position: absolute;z-index: 99999"
      />
    </div>
    <div class="row myrow content-mb-42">
      <div class="col-xs-12 mycol">
        <table
          class="c-indicator c-indicator-w-100 table-top-bd table-top-bd_fix"
          style="width: 100%"
          v-scroll="handleScroll"
        >
          <thead>
            <tr>
              <th style="width: 80px;">№ п/п</th>
              <th style="width: 525px;">
                Направления целевого использования средств
              </th>
              <th>
                Зарплата сотрудников, вкл. налоги и взносы от ФОТ
              </th>
              <th>
                Работы и услуги, выполняемые третьими лицами, приобретение прав
              </th>
              <th>Материалы и комплектующие</th>
              <th>Приобретение оборудования</th>
              <th>Итого</th>
            </tr>
          </thead>
          <tbody>
            <template
              v-for="(articles, index) in project.BUDGET.BUDGET_ARTICLE_ID"
            >
              <tr
                v-if="
                  articles.length > 1 ||
                    articles[0].UF_BUDGET_ARTICLE_SECTION_CODE ==
                      'new_tehnolog' ||
                    articles[0].UF_BUDGET_ARTICLE_SECTION_CODE == 'inginiring'
                "
                v-bind:key="index"
              >
                <td>{{ budgetIndex(index) }}</td>
                <td>
                  {{ articles[0].UF_BUDGET_ARTICLE_SECTION_NAME }}
                </td>
                <td>
                  <strong>{{
                    calcArticlesSum(articles, "UF_ZARPLATA_ZAIM") | toCurrency
                  }}</strong>
                </td>
                <td>
                  <strong>{{
                    calcArticlesSum(articles, "UF_JOB_ZAIM") | toCurrency
                  }}</strong>
                </td>
                <td>
                  <strong>{{
                    calcArticlesSum(articles, "UF_MATERIAL_ZAIM") | toCurrency
                  }}</strong>
                </td>
                <td>
                  <strong>{{
                    calcArticlesSum(articles, "UF_OBORUD_ZAIM") | toCurrency
                  }}</strong>
                </td>
                <td>
                  <strong>{{
                    calcArticlesSum(articles, "UF_ITOGO_ZAIM") | toCurrency
                  }}</strong>
                </td>
              </tr>
              <tr
                v-for="(article, articleIndex) in articles"
                v-bind:value="article.UF_BUDGET_ARTICLE_ID"
                v-bind:key="article.UF_BUDGET_ARTICLE_ID"
              >
                <td
                  v-if="
                    articles.length === 1 &&
                      articles[0].UF_BUDGET_ARTICLE_SECTION_CODE !=
                        'new_tehnolog' &&
                      articles[0].UF_BUDGET_ARTICLE_SECTION_CODE != 'inginiring'
                  "
                >
                  {{ budgetIndex(index) }}
                </td>
                <td v-else>{{ budgetIndex(index) }}.{{ articleIndex + 1 }}</td>
                <td>
                  {{ article.UF_BUDGET_ARTICLE_NAME }}
                </td>

                <td
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_ZARPLATA_ZAIM'
                    )
                  }"
                >
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    v-model="
                      project.BUDGET.items[article.UF_BUDGET_ARTICLE_ID]
                        .UF_ZARPLATA_ZAIM
                    "
                    v-on:change="
                      removeBudgetError(article.UF_BUDGET_ARTICLE_ID)
                    "
                    class="i-main-style tab-wid-97"
                    :disabled="article.IS_ZARPLATA_ZAIM_BLOCK === 1"
                  />
                </td>
                <td
                  v-show="false"
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_ZARPLATA_SOFIN'
                    )
                  }"
                >
                  <input
                    v-model="
                      project.BUDGET.items[article.UF_BUDGET_ARTICLE_ID]
                        .UF_ZARPLATA_SOFIN
                    "
                    v-on:change="
                      removeBudgetError(article.UF_BUDGET_ARTICLE_ID)
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="article.IS_ZARPLATA_SOFIN_BLOCK === 1"
                  />

                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    v-model="
                      project.BUDGET.items[article.UF_BUDGET_ARTICLE_ID]
                        .UF_ZARPLATA_ZAIM
                    "
                    v-on:change="
                      removeBudgetError(article.UF_BUDGET_ARTICLE_ID)
                    "
                    class="i-main-style tab-wid-97"
                    :disabled="article.IS_ZARPLATA_ZAIM_BLOCK === 1"
                  />
                </td>
                <td
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_JOB_ZAIM'
                    )
                  }"
                >
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    v-model="
                      project.BUDGET.items[article.UF_BUDGET_ARTICLE_ID]
                        .UF_JOB_ZAIM
                    "
                    v-on:change="
                      removeBudgetError(article.UF_BUDGET_ARTICLE_ID)
                    "
                    class="i-main-style tab-wid-97"
                    :disabled="article.IS_JOB_ZAIM_BLOCK === 1"
                  />
                </td>
                <td
                  v-show="false"
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_JOB_SOFIN'
                    )
                  }"
                >
                  <input
                    v-model="
                      project.BUDGET.items[article.UF_BUDGET_ARTICLE_ID]
                        .UF_JOB_SOFIN
                    "
                    v-on:change="
                      removeBudgetError(article.UF_BUDGET_ARTICLE_ID)
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="article.IS_JOB_SOFIN_BLOCK === 1"
                  />
                </td>
                <td
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_MATERIAL_ZAIM'
                    )
                  }"
                >
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    v-model="
                      project.BUDGET.items[article.UF_BUDGET_ARTICLE_ID]
                        .UF_MATERIAL_ZAIM
                    "
                    v-on:change="
                      removeBudgetError(article.UF_BUDGET_ARTICLE_ID)
                    "
                    class="i-main-style tab-wid-97"
                    :disabled="article.IS_MATERIAL_ZAIM_BLOCK === 1"
                  />
                </td>
                <td
                  v-show="false"
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_MATERIAL_SOFIN'
                    )
                  }"
                >
                  <input
                    v-model="
                      project.BUDGET.items[article.UF_BUDGET_ARTICLE_ID]
                        .UF_MATERIAL_SOFIN
                    "
                    v-on:change="
                      removeBudgetError(article.UF_BUDGET_ARTICLE_ID)
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="article.IS_MATERIAL_SOFIN_BLOCK === 1"
                  />
                </td>
                <td
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_OBORUD_ZAIM'
                    )
                  }"
                >
                  <vue-numeric
                    separator="space"
                    output-type="Number"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    v-model="
                      project.BUDGET.items[article.UF_BUDGET_ARTICLE_ID]
                        .UF_OBORUD_ZAIM
                    "
                    v-on:change="
                      removeBudgetError(article.UF_BUDGET_ARTICLE_ID)
                    "
                    class="i-main-style tab-wid-97"
                    :disabled="article.IS_OBORUD_ZAIM_BLOCK === 1"
                  />
                </td>
                <td
                  v-show="false"
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_OBORUD_SOFIN'
                    )
                  }"
                >
                  <input
                    v-model="
                      project.BUDGET.items[article.UF_BUDGET_ARTICLE_ID]
                        .UF_OBORUD_SOFIN
                    "
                    v-on:change="
                      removeBudgetError(article.UF_BUDGET_ARTICLE_ID)
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="article.IS_OBORUD_SOFIN_BLOCK === 1"
                  />
                </td>
                <td
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_ITOGO_ZAIM'
                    )
                  }"
                >
                  <input
                    v-bind:value="
                      calcBudgetRowZaim(article.UF_BUDGET_ARTICLE_ID)
                    "
                    type="text"
                    class="i-main-style tab-wid-97"
                    disabled
                  />
                </td>
                <td
                  v-show="false"
                  v-bind:class="{
                    'has-error': hasBudgetError(
                      article.UF_BUDGET_ARTICLE_ID,
                      'UF_ITOGO_SOFIN'
                    )
                  }"
                >
                  <input
                    v-bind:value="
                      calcBudgetRowSofin(article.UF_BUDGET_ARTICLE_ID)
                    "
                    type="text"
                    class="i-main-style tab-wid-97"
                    disabled
                  />
                </td>
              </tr>
            </template>
            <tr class="tr-foot-itog">
              <td colspan="2" class="pd-col-62">ИТОГО</td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_ZARPLATA_ZAIM') | toCurrency"
                />
              </td>
              <td v-show="false">
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_ZARPLATA_SOFIN') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_JOB_ZAIM') | toCurrency"
                />
              </td>
              <td v-show="false">
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_JOB_SOFIN') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_MATERIAL_ZAIM') | toCurrency"
                />
              </td>
              <td v-show="false">
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_MATERIAL_SOFIN') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_OBORUD_ZAIM') | toCurrency"
                />
              </td>
              <td v-show="false">
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_OBORUD_SOFIN') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_ITOGO_ZAIM') | toCurrency"
                />
              </td>
              <td v-show="false">
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetSum('UF_ITOGO_SOFIN') | toCurrency"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row myrow content-mb-42">
      <div class="col-xs-12 mycol">
        <div class="h3-tab-title">
          В том числе распределение по годам, тыс. руб.
        </div>
        <table
          class="c-indicator content-mb-25 c-indicator-w-100 table-top-bd"
          v-scroll="handleScroll"
          style="width: 100%"
        >
          <thead>
            <tr>
              <th style="width: 240px;">Год</th>
              <th style="width: 367px;"></th>
              <th>
                Зарплата сотрудников, вкл. налоги и взносы от ФОТ
              </th>
              <th>
                Работы и услуги, выполняемые третьими лицами, приобретение прав
              </th>
              <th>Материалы и комплектующие</th>
              <th>Приобретение оборудования</th>
              <th>Итого</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="year in budgetYears">
              <tr
                v-if="year !== project.BUDGET_YEAR.YearTwoLine"
                v-bind:key="year"
              >
                <td>{{ year }}</td>
                <td></td>
                <td>
                  <input
                    v-model="
                      project.BUDGET_YEAR.items[year][0].UF_ZARPLATA_ZAIM
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_ZARPLATA_ZAIM_BLOCK === 1
                    "
                  />
                </td>
                <td v-show="false">
                  <input
                    v-model="
                      project.BUDGET_YEAR.items[year][0].UF_ZARPLATA_SOFIN
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_ZARPLATA_SOFIN_BLOCK === 1
                    "
                  />
                </td>
                <td>
                  <input
                    v-model="project.BUDGET_YEAR.items[year][0].UF_JOB_ZAIM"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_JOB_ZAIM_BLOCK === 1
                    "
                  />
                </td>
                <td v-show="false">
                  <input
                    v-model="project.BUDGET_YEAR.items[year][0].UF_JOB_SOFIN"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_JOB_SOFIN_BLOCK === 1
                    "
                  />
                </td>
                <td>
                  <input
                    v-model="
                      project.BUDGET_YEAR.items[year][0].UF_MATERIAL_ZAIM
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_MATERIAL_ZAIM_BLOCK === 1
                    "
                  />
                </td>
                <td v-show="false">
                  <input
                    v-model="
                      project.BUDGET_YEAR.items[year][0].UF_MATERIAL_SOFIN
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_MATERIAL_SOFIN_BLOCK === 1
                    "
                  />
                </td>
                <td>
                  <input
                    v-model="project.BUDGET_YEAR.items[year][0].UF_OBORUD_ZAIM"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_OBORUD_ZAIM_BLOCK === 1
                    "
                  />
                </td>
                <td v-show="false">
                  <input
                    v-model="project.BUDGET_YEAR.items[year][0].UF_OBORUD_SOFIN"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_OBORUD_SOFIN_BLOCK === 1
                    "
                  />
                </td>
                <td>
                  <input
                    v-bind:value="calcBudgetYearsRowZaim(year, 0)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    disabled
                  />
                </td>
                <td v-show="false">
                  <input
                    v-bind:value="calcBudgetYearsRowSofin(year, 0)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    disabled
                  />
                </td>
              </tr>
              <tr
                v-show="false"
                v-if="year === project.BUDGET_YEAR.YearTwoLine"
                v-bind:key="year"
              >
                <td>{{ year }} (уже понесенные расходы)</td>
                <td></td>
                <td>
                  <input
                    v-model="
                      project.BUDGET_YEAR.items[year][0].UF_ZARPLATA_ZAIM
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_ZARPLATA_ZAIM_BLOCK === 1
                    "
                  />
                </td>
                <td v-show="false">
                  <input
                    v-model="
                      project.BUDGET_YEAR.items[year][0].UF_ZARPLATA_SOFIN
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_ZARPLATA_SOFIN_BLOCK === 1
                    "
                  />
                </td>
                <td>
                  <input
                    v-model="project.BUDGET_YEAR.items[year][0].UF_JOB_ZAIM"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_JOB_ZAIM_BLOCK === 1
                    "
                  />
                </td>
                <td v-show="false">
                  <input
                    v-model="project.BUDGET_YEAR.items[year][0].UF_JOB_SOFIN"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_JOB_SOFIN_BLOCK === 1
                    "
                  />
                </td>
                <td>
                  <input
                    v-model="
                      project.BUDGET_YEAR.items[year][0].UF_MATERIAL_ZAIM
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_MATERIAL_ZAIM_BLOCK === 1
                    "
                  />
                </td>
                <td v-show="false">
                  <input
                    v-model="
                      project.BUDGET_YEAR.items[year][0].UF_MATERIAL_SOFIN
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_MATERIAL_SOFIN_BLOCK === 1
                    "
                  />
                </td>
                <td>
                  <input
                    v-model="project.BUDGET_YEAR.items[year][0].UF_OBORUD_ZAIM"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_OBORUD_ZAIM_BLOCK === 1
                    "
                  />
                </td>
                <td v-show="false">
                  <input
                    v-model="project.BUDGET_YEAR.items[year][0].UF_OBORUD_SOFIN"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    :disabled="
                      project.BUDGET_YEAR.YearBlockInfo[year]
                        .IS_OBORUD_SOFIN_BLOCK === 1
                    "
                  />
                </td>
                <td>
                  <input
                    v-bind:value="calcBudgetYearsRowZaim(year, 0)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    disabled
                  />
                </td>
                <td v-show="false">
                  <input
                    v-bind:value="calcBudgetYearsRowSofin(year, 0)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    disabled
                  />
                </td>
              </tr>
              <tr
                :key="year + '_'"
                v-if="year === project.BUDGET_YEAR.YearTwoLine"
              >
                <td>{{ year }}</td>
                <td></td>
                <td>
                  <input
                    v-model="
                      project.BUDGET_YEAR.items[year][1].UF_ZARPLATA_ZAIM
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                  />
                </td>
                <td v-show="false">
                  <input
                    v-model="
                      project.BUDGET_YEAR.items[year][1].UF_ZARPLATA_SOFIN
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                  />
                </td>
                <td>
                  <input
                    v-model="project.BUDGET_YEAR.items[year][1].UF_JOB_ZAIM"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                  />
                </td>
                <td v-show="false">
                  <input
                    v-model="project.BUDGET_YEAR.items[year][1].UF_JOB_SOFIN"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                  />
                </td>
                <td>
                  <input
                    v-model="
                      project.BUDGET_YEAR.items[year][1].UF_MATERIAL_ZAIM
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                  />
                </td>
                <td v-show="false">
                  <input
                    v-model="
                      project.BUDGET_YEAR.items[year][1].UF_MATERIAL_SOFIN
                    "
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                  />
                </td>
                <td>
                  <input
                    v-model="project.BUDGET_YEAR.items[year][1].UF_OBORUD_ZAIM"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                  />
                </td>
                <td v-show="false">
                  <input
                    v-model="project.BUDGET_YEAR.items[year][1].UF_OBORUD_SOFIN"
                    v-on:keypress="isNumber($event)"
                    type="text"
                    class="i-main-style tab-wid-97"
                  />
                </td>
                <td>
                  <input
                    v-bind:value="calcBudgetYearsRowZaim(year, 1)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    disabled
                  />
                </td>
                <td v-show="false">
                  <input
                    v-bind:value="calcBudgetYearsRowSofin(year, 1)"
                    type="text"
                    class="i-main-style tab-wid-97"
                    disabled
                  />
                </td>
              </tr>
            </template>
            <tr class="tr-foot-itog">
              <td class="pd-col-62">ИТОГО</td>
              <td></td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_ZARPLATA_ZAIM') | toCurrency"
                />
              </td>
              <td v-show="false">
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_ZARPLATA_SOFIN') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_JOB_ZAIM') | toCurrency"
                />
              </td>
              <td v-show="false">
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_JOB_SOFIN') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_MATERIAL_ZAIM') | toCurrency"
                />
              </td>
              <td v-show="false">
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_MATERIAL_SOFIN') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_OBORUD_ZAIM') | toCurrency"
                />
              </td>
              <td v-show="false">
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_OBORUD_SOFIN') | toCurrency"
                />
              </td>
              <td>
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_ITOGO_ZAIM') | toCurrency"
                />
              </td>
              <td v-show="false">
                <input
                  type="text"
                  class="t-result-style tab-wid-97"
                  :value="calcBudgetYearsSum('UF_ITOGO_SOFIN') | toCurrency"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    </fieldset>
  </div>
  <!--container-fluid-->
</template>

<script>
import { mapGetters } from "vuex";
import Vue from "vue";
import { FETCH_DIRECTORIES } from "@/store/actions.type";
import Bank_guarantee from "@/components/project/form/partial/BankGuarantee";

export default {
  name: "step3",
  components: { Bank_guarantee },
  props: ["step", "project"],
  data() {
    return {
      loaded: false,
      h16tooltipShow: false,
      h16tooltip:
        "<img src='https://lkbe.frprf.ru//images/project/p15_info.png' />"
    };
  },
  mounted() {
    this.$store
      .dispatch(FETCH_DIRECTORIES, [
        "program_fin_support",
        "status_all",
        "status"
      ])
      .then(() => {
        this.$nextTick(this.initializeBudgetData);
      });
  },
  watch: {
    project: {
      handler() {
        this.initializeBudgetData();
      },
      deep: true
    }
  },
  methods: {
    initializeBudgetData() {
      if (this.project && this.project.BUDGET) {
        if (this.project.BUDGET.items.length === 0) {
          this.project.BUDGET.items = new Object();
        }

        for (let articles in this.project.BUDGET.BUDGET_ARTICLE_ID) {
          this.project.BUDGET.BUDGET_ARTICLE_ID[articles].forEach(function(
            item
          ) {
            if (
              typeof this.project.BUDGET.items[item.UF_BUDGET_ARTICLE_ID] ===
              "undefined"
            ) {
              Vue.set(this.project.BUDGET.items, item.UF_BUDGET_ARTICLE_ID, {
                ID: 0,
                UF_BUDGET_ARTICLE_ID: item.UF_BUDGET_ARTICLE_ID,
                UF_ITOGO_SOFIN: 0,
                UF_ITOGO_ZAIM: 0,
                UF_JOB_SOFIN: 0,
                UF_JOB_ZAIM: 0,
                UF_MATERIAL_SOFIN: 0,
                UF_MATERIAL_ZAIM: 0,
                UF_OBORUD_SOFIN: 0,
                UF_OBORUD_ZAIM: 0,
                UF_PROJECT_ID: this.project.ID,
                UF_ZARPLATA_SOFIN: 0,
                UF_ZARPLATA_ZAIM: 0
              });
            }
          },
          this);
        }
        if (
          this.project.BUDGET_YEAR.items[this.project.BUDGET_YEAR.YearTwoLine]
            .length < 2
        ) {
          Vue.set(
            this.project.BUDGET_YEAR.items[
              this.project.BUDGET_YEAR.YearTwoLine
            ],
            1,
            {
              UF_IS_ALREADY: 0,
              UF_ITOGO_SOFIN: 0,
              UF_ITOGO_ZAIM: 0,
              UF_JOB_SOFIN: 0,
              UF_JOB_ZAIM: 0,
              UF_MATERIAL_SOFIN: 0,
              UF_MATERIAL_ZAIM: 0,
              UF_OBORUD_SOFIN: 0,
              UF_OBORUD_ZAIM: 0,
              UF_PROJECT_ID: this.project.ID,
              UF_YEAR: this.project.BUDGET_YEAR.YearTwoLine,
              UF_ZARPLATA_SOFIN: 0,
              UF_ZARPLATA_ZAIM: 0
            }
          );
        }
      }
      this.loaded = true;
    },
    stepNumber(num) {
      let steps = {
        16: 16,
        17: 17
      };
      if (
        this.programCode(this.project.UF_SUPPORT_PROG_ID) === "cifrovizaciya"
      ) {
        steps = {
          16: 19,
          17: 20
        };
      }
      if (this.programCode(this.project.UF_SUPPORT_PROG_ID) === "lekarstva") {
        steps = {
          16: 17,
          17: 18
        };
      }
      return steps[num] + (this.project.UF_SETTING && this.project.UF_SETTING.IS_VIEW_OKPO_COMPANY == 1 ? 1 : 0);
    },
    programCode(id) {
      let els = this.directory.program_fin_support.filter(function(el) {
        if (el.ID == id) {
          return true;
        }
        return false;
      }, this);
      if (els.length > 0) {
        return els[0].CODE;
      }
      return "";
    },
    hasBudgetError(id, field) {
      if (typeof this.$parent.budgetErrors[id] !== "undefined") {
        if (typeof this.$parent.budgetErrors[id][field] !== "undefined") {
          return true;
        }
      }
      return false;
    },
    removeBudgetError(id) {
      if (typeof this.$parent.budgetErrors[id] !== "undefined") {
        Vue.delete(this.$parent.budgetErrors, id);
      }
      return false;
    },
    calcBudgetRowZaim(item) {
      let i = this.project.BUDGET.items[item];
      if (i.UF_ZARPLATA_ZAIM === "") i.UF_ZARPLATA_ZAIM = 0;
      if (i.UF_JOB_ZAIM === "") i.UF_JOB_ZAIM = 0;
      if (i.UF_MATERIAL_ZAIM === "") i.UF_MATERIAL_ZAIM = 0;
      if (i.UF_OBORUD_ZAIM === "") i.UF_OBORUD_ZAIM = 0;
      let sum =
        parseInt(i.UF_ZARPLATA_ZAIM) +
        parseInt(i.UF_JOB_ZAIM) +
        parseInt(i.UF_MATERIAL_ZAIM) +
        parseInt(i.UF_OBORUD_ZAIM);

      this.project.BUDGET.items[item].UF_ITOGO_ZAIM = sum;
      return sum;
    },
    calcBudgetRowSofin(item) {
      let i = this.project.BUDGET.items[item];
      if (i.UF_ZARPLATA_SOFIN === "") i.UF_ZARPLATA_SOFIN = 0;
      if (i.UF_JOB_SOFIN === "") i.UF_JOB_SOFIN = 0;
      if (i.UF_MATERIAL_SOFIN === "") i.UF_MATERIAL_SOFIN = 0;
      if (i.UF_OBORUD_SOFIN === "") i.UF_OBORUD_SOFIN = 0;
      let sum =
        parseInt(i.UF_ZARPLATA_SOFIN) +
        parseInt(i.UF_JOB_SOFIN) +
        parseInt(i.UF_MATERIAL_SOFIN) +
        parseInt(i.UF_OBORUD_SOFIN);

      this.project.BUDGET.items[item].UF_ITOGO_SOFIN = sum;
      return sum;
    },
    calcBudgetYearsRowZaim(item, k) {
      let i = this.project.BUDGET_YEAR.items[item][k];
      let sum =
        parseInt(i.UF_ZARPLATA_ZAIM) +
        parseInt(i.UF_JOB_ZAIM) +
        parseInt(i.UF_MATERIAL_ZAIM) +
        parseInt(i.UF_OBORUD_ZAIM);

      this.project.BUDGET_YEAR.items[item][k].UF_ITOGO_ZAIM = sum;
      return sum;
    },
    calcBudgetYearsRowSofin(item, k) {
      let i = this.project.BUDGET_YEAR.items[item][k];
      let sum =
        parseInt(i.UF_ZARPLATA_SOFIN) +
        parseInt(i.UF_JOB_SOFIN) +
        parseInt(i.UF_MATERIAL_SOFIN) +
        parseInt(i.UF_OBORUD_SOFIN);

      this.project.BUDGET_YEAR.items[item][k].UF_ITOGO_SOFIN = sum;
      return sum;
    },
    calcBudgetSum(field) {
      let sum = 0;
      Object.keys(this.project.BUDGET.items).map(function(objectKey) {
        sum += parseInt(this.project.BUDGET.items[objectKey][field]);
      }, this);
      return sum;
    },
    calcBudgetYearsSum(field) {
      let sum = 0;
      Object.keys(this.project.BUDGET_YEAR.items).map(function(objectKey) {
        sum += parseInt(this.project.BUDGET_YEAR.items[objectKey][0][field]);
        if (this.project.BUDGET_YEAR.items[objectKey].length > 1) {
          sum += parseInt(this.project.BUDGET_YEAR.items[objectKey][1][field]);
        }
      }, this);
      return sum;
    },
    calcArticlesSum(articles, field) {
      let sum = 0;
      articles.forEach(function(article) {
        sum += parseInt(
          this.project.BUDGET.items[article.UF_BUDGET_ARTICLE_ID][field]
        );
      }, this);
      return sum;
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    budgetIndex(i) {
      let budgetIndex;
      let k = Object.keys(this.project.BUDGET.BUDGET_ARTICLE_ID);
      for (budgetIndex = 0; budgetIndex < k.length; budgetIndex++) {
        if (k[budgetIndex] == i) {
          break;
        }
      }
      return budgetIndex + 1;
    },
    handleScroll: function(evt, el) {
      if (window.scrollY > 100) {
        if (el.classList.contains("table-top-bd")) {
          el.classList.add("table-top-bd_fix");
        }
      } else {
        if (el.classList.contains("table-top-bd")) {
          el.classList.remove("table-top-bd_fix");
        }
      }
    }
  },
  directives: {
    scroll: {
      // определение директивы
      inserted: function(el, binding) {
        let f = function(evt) {
          if (binding.value(evt, el)) {
            window.removeEventListener("scroll", f);
          }
        };
        window.addEventListener("scroll", f);
      }
    }
  },
  computed: {
    okpoShift() {
      return this.project.UF_SETTING &&
        this.project.UF_SETTING.IS_VIEW_OKPO_COMPANY == 1
        ? 1
        : 0;
    },
    mobOkpdShift() {
      return this.project.UF_SETTING &&
        this.project.UF_SETTING.IS_MOBILIZATION_VIEW_OKPD == 1
        ? 2
        : 0;
    },
    budgetYears() {
      let years = [];
      for (
        let i = this.project.BUDGET_YEAR.yearStart;
        i <= this.project.BUDGET_YEAR.yearEnd;
        i++
      ) {
        years.push(i);
      }
      return years;
    },
    isResumeCoordinated() {
      const list = this.project && this.project.COORDINATIONS;
      if (!Array.isArray(list)) {
        return false;
      }
      return list.some(
        el =>
          el &&
          el.UF_TYPE_PAGE === "rezume_10_01" &&
          (el.UF_IS_COORDINATION == 1 || el.UF_IS_COORDINATION === true)
      );
    },
    ...mapGetters(["directory"])
  }
};
</script>

<style scoped></style>
